(function () {
  document.documentElement.classList.remove("no-js");

  const SELECTORS = {
    drawerTrigger: "[data-drawer-target]",
    modalTrigger: "[data-modal-target]",
    drawerClose: "[data-drawer-close]",
    drawerOverlay: ".drawer__overlay",
    quickAdd: "[data-quick-add]",
    quickAddOpen: "[data-quick-add-open]",
    quickAddClose: "[data-quick-add-close]",
    modalClose: "[data-modal-close]",
    qty: "[data-quantity]",
    cartChange: "[data-cart-change]",
    dragScroll: "[data-drag-scroll]",
    scrollRunway: "[data-scroll-runway]",
    scrollRunwayTrack: "[data-scroll-runway-track]",
    variantRoot: "[data-product-form]",
    recommendations: "[data-product-recommendations]",
    recentlyViewed: "[data-recently-viewed]",
    infiniteGrid: "[data-infinite-grid]"
  };

  const state = {
    activeDrawer: null,
    activeModal: null,
    activeQuickAdd: null
  };

  function qs(selector, scope = document) {
    return scope.querySelector(selector);
  }

  function qsa(selector, scope = document) {
    return Array.from(scope.querySelectorAll(selector));
  }

  function debounce(fn, wait = 150) {
    let timer;
    return function debounced() {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD"
    }).format((Number(cents) || 0) / 100);
  }

  function trapEscape(event) {
    if (event.key !== "Escape") return;
    closeQuickAdd();
    closeDrawer();
    closeModal();
  }

  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    closeDrawer();
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("drawer-open");
    state.activeDrawer = drawer;
    const focusTarget = qs("button, a, input, select, textarea", drawer);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!state.activeDrawer) return;
    qsa("[data-facets-form]", state.activeDrawer).forEach((form) => resetFacetPanels(form));
    state.activeDrawer.classList.remove("is-open");
    state.activeDrawer.setAttribute("aria-hidden", "true");
    state.activeDrawer = null;
    document.body.classList.remove("drawer-open");
  }

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    closeModal();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-open");
    state.activeModal = modal;
    const focusTarget = qs("button, a, input, select, textarea", modal);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!state.activeModal) return;
    state.activeModal.classList.remove("is-open");
    state.activeModal.setAttribute("aria-hidden", "true");
    state.activeModal = null;
    document.body.classList.remove("modal-open");
  }

  function openQuickAdd(trigger) {
    const scope = trigger.closest("[data-quick-add-scope], [data-product-card], .cart-upsell");
    const modal = scope ? qs("[data-quick-add-modal]", scope) : null;
    if (!modal) return;
    closeQuickAdd();
    closeModal();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-open");
    state.activeQuickAdd = modal;
    initVariantForms(modal);
    const focusTarget = qs("input:checked, button, a, input, select, textarea", modal);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function closeQuickAdd() {
    if (!state.activeQuickAdd) return;
    state.activeQuickAdd.classList.remove("is-open");
    state.activeQuickAdd.setAttribute("aria-hidden", "true");
    state.activeQuickAdd = null;
    if (!state.activeModal) document.body.classList.remove("modal-open");
  }

  function openPreviewQuickAdd(form) {
    let modal = qs("[data-preview-quick-add-modal]");
    const productTitle = qs(".product-card__title", form.closest("[data-product-card]"))?.textContent.trim() || "this item";

    if (!modal) {
      document.body.insertAdjacentHTML("beforeend", `
        <div class="quick-add-modal" data-quick-add-modal data-preview-quick-add-modal aria-hidden="true" role="dialog" aria-modal="true" aria-label="Select size">
          <button class="quick-add-modal__overlay" type="button" data-quick-add-close aria-label="Close options"></button>
          <div class="quick-add-modal__panel">
            <div class="quick-add-modal__header">
              <h3 data-preview-quick-add-title>Select size</h3>
              <button class="quick-add-modal__close" type="button" data-quick-add-close aria-label="Close options"><span aria-hidden="true">&times;</span></button>
            </div>
            <form class="quick-add-options" data-product-form data-quick-add data-preview>
              <select class="sr-only" name="id" data-variant-select>
                <option value="preview-xs" data-options='["XS"]' data-available="true" selected>XS</option>
                <option value="preview-s" data-options='["S"]' data-available="true">S</option>
                <option value="preview-m" data-options='["M"]' data-available="false">M</option>
                <option value="preview-l" data-options='["L"]' data-available="true">L</option>
                <option value="preview-xl" data-options='["XL"]' data-available="true">XL</option>
              </select>
              <fieldset class="quick-add-options__fieldset variant-fieldset">
                <legend>Size</legend>
                <div class="quick-add-options__values variant-options">
                  <label class="quick-add-options__value variant-option"><input type="radio" name="preview-size" value="XS" data-option-radio checked><span>XS</span></label>
                  <label class="quick-add-options__value variant-option"><input type="radio" name="preview-size" value="S" data-option-radio><span>S</span></label>
                  <label class="quick-add-options__value variant-option"><input type="radio" name="preview-size" value="M" data-option-radio><span>M</span></label>
                  <label class="quick-add-options__value variant-option"><input type="radio" name="preview-size" value="L" data-option-radio><span>L</span></label>
                  <label class="quick-add-options__value variant-option"><input type="radio" name="preview-size" value="XL" data-option-radio><span>XL</span></label>
                </div>
              </fieldset>
              <button class="quick-add-options__submit" type="submit" data-available-text="Add to bag">Add to bag</button>
            </form>
          </div>
        </div>
      `);
      modal = qs("[data-preview-quick-add-modal]");
    }

    const title = qs("[data-preview-quick-add-title]", modal);
    if (title) title.textContent = `Select size: ${productTitle}`;
    closeQuickAdd();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("modal-open");
    state.activeQuickAdd = modal;
    initVariantForms(modal);
    const focusTarget = qs("input:checked, button, a, input, select, textarea", modal);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function updateCartCount(count) {
    qsa("[data-cart-count]").forEach((node) => {
      node.textContent = count;
      node.setAttribute("aria-label", `${count} items in cart`);
    });
    qsa("[data-cart-drawer-title]").forEach((node) => {
      node.textContent = `Bag (${count})`;
    });
  }

  async function refreshCartDrawer() {
    const drawerBody = qs("[data-cart-drawer-body]");
    const drawerFooter = qs("[data-cart-drawer-footer]");
    if (!drawerBody || !window.fetch) return;

    try {
      const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const next = qs("[data-cart-drawer-body]", doc);
      const nextFooter = qs("[data-cart-drawer-footer]", doc);
      const count = qs("[data-cart-count-source]", doc);
      const title = qs("[data-cart-drawer-title]", doc);
      if (next) drawerBody.innerHTML = next.innerHTML;
      if (nextFooter && drawerFooter) drawerFooter.innerHTML = nextFooter.innerHTML;
      if (title) qsa("[data-cart-drawer-title]").forEach((node) => { node.textContent = title.textContent.trim(); });
      if (count) updateCartCount(count.textContent.trim());
    } catch (error) {
      console.warn("Cart drawer refresh failed", error);
    }
  }

  async function handleCartChange(event) {
    const button = event.target.closest(SELECTORS.cartChange);
    if (!button) return;
    event.preventDefault();

    const line = Number(button.dataset.line);
    const quantity = Math.max(0, Number(button.dataset.quantity));
    if (!line || Number.isNaN(quantity)) return;

    button.disabled = true;
    try {
      const cart = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ line, quantity })
      }).then((res) => {
        if (!res.ok) throw new Error("Cart update failed");
        return res.json();
      });
      updateCartCount(cart.item_count);
      await refreshCartDrawer();
      openDrawer("CartDrawer");
    } catch (error) {
      console.warn(error);
      button.disabled = false;
    }
  }

  function showFormError(form, message) {
    let el = qs("[data-cart-error]", form);
    if (!el) {
      el = document.createElement("p");
      el.className = "product-form__error";
      el.setAttribute("data-cart-error", "");
      el.setAttribute("role", "alert");
      el.setAttribute("aria-live", "assertive");
      const submit = qs("button[type='submit']", form);
      const anchor = submit ? (submit.closest(".product-actions") || submit) : null;
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(el, anchor.nextSibling);
      } else {
        form.appendChild(el);
      }
    }
    el.textContent = message;
    el.hidden = false;
  }

  function clearFormError(form) {
    const el = qs("[data-cart-error]", form);
    if (el) {
      el.textContent = "";
      el.hidden = true;
    }
  }

  async function handleQuickAdd(event) {
    const form = event.target.closest(SELECTORS.quickAdd);
    if (!form) return;
    event.preventDefault();

    if (form.hasAttribute("data-preview") && !form.hasAttribute("data-product-form") && form.closest("[data-product-card]")) {
      openPreviewQuickAdd(form);
      return;
    }

    clearFormError(form);

    const button = qs("button[type='submit']", form);
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = "Adding";
    }

    if (form.hasAttribute("data-preview")) {
      const current = Number(qs("[data-cart-count]")?.textContent || 0) + 1;
      updateCartCount(current);
      if (button) button.textContent = "Added";
      closeQuickAdd();
      openDrawer("CartDrawer");
      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || "Add";
        }
      }, 900);
      return;
    }

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      });
      if (!res.ok) {
        let message = "Sorry, we couldn't add that to your bag.";
        try {
          const data = await res.json();
          message = data.description || data.message || message;
        } catch (parseError) {
          /* response had no JSON body */
        }
        throw new Error(message);
      }
      const cart = await fetch("/cart.js").then((cartRes) => cartRes.json());
      updateCartCount(cart.item_count);
      await refreshCartDrawer();
      clearFormError(form);
      closeQuickAdd();
      openDrawer("CartDrawer");
    } catch (error) {
      console.warn(error);
      showFormError(form, error.message || "Sorry, we couldn't add that to your bag.");
      if (button) button.textContent = "Try again";
    } finally {
      setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || "Add to cart";
        }
      }, 900);
    }
  }

  function handleQuantityClick(event) {
    const button = event.target.closest("[data-quantity-button]");
    if (!button) return;
    const root = button.closest(SELECTORS.qty);
    const input = qs("input", root);
    if (!input) return;
    const step = button.dataset.quantityButton === "plus" ? 1 : -1;
    const min = Number(input.min || 1);
    input.value = Math.max(min, Number(input.value || min) + step);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function syncVariant(root) {
    const select = qs("[data-variant-select]", root);
    if (!select) return;
    const selectedOptions = qsa("[data-option-radio]:checked", root).map((input) => input.value);
    if (!selectedOptions.length) return;

    const option = qsa("option", select).find((item) => {
      try {
        return JSON.stringify(JSON.parse(item.dataset.options || "[]")) === JSON.stringify(selectedOptions);
      } catch (error) {
        return false;
      }
    });

    if (!option) return;
    select.value = option.value;
    const submit = qs("[type='submit']", root);
    const available = option.dataset.available === "true";
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? submit.dataset.availableText || "Add to cart" : "Sold out";
    }
  }

  function initVariantForms(scope = document) {
    qsa(SELECTORS.variantRoot, scope).forEach((root) => {
      if (root.dataset.variantBound !== "true") {
        qsa("[data-option-radio]", root).forEach((radio) => {
          radio.addEventListener("change", () => syncVariant(root));
        });
        root.dataset.variantBound = "true";
      }
      syncVariant(root);
    });
  }

  function initStickyAtc() {
    const sticky = qs("[data-sticky-atc]");
    const mainSubmit = qs("[data-main-submit]");
    if (!sticky || !mainSubmit || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle("is-visible", !entry.isIntersecting);
      },
      { threshold: 0.2 }
    );
    observer.observe(mainSubmit);
  }

  async function loadRecommendations() {
    const root = qs(SELECTORS.recommendations);
    if (!root || !root.dataset.url || root.dataset.loaded === "true") return;
    try {
      const html = await fetch(root.dataset.url).then((res) => res.text());
      const doc = new DOMParser().parseFromString(html, "text/html");
      const incoming = qs(SELECTORS.recommendations, doc);
      if (incoming && incoming.innerHTML.trim()) {
        root.innerHTML = incoming.innerHTML;
        root.dataset.loaded = "true";
      }
    } catch (error) {
      console.warn("Recommendations failed", error);
    }
  }

  function rememberProduct() {
    const marker = qs("[data-current-product]");
    if (!marker) return;
    const handle = marker.dataset.handle;
    if (!handle) return;
    const items = JSON.parse(localStorage.getItem("rr_recently_viewed") || "[]").filter((item) => item !== handle);
    items.unshift(handle);
    localStorage.setItem("rr_recently_viewed", JSON.stringify(items.slice(0, 8)));
  }

  async function hydrateRecentlyViewed() {
    const root = qs(SELECTORS.recentlyViewed);
    if (!root || !window.fetch) return;
    const current = qs("[data-current-product]")?.dataset.handle;
    const handles = JSON.parse(localStorage.getItem("rr_recently_viewed") || "[]")
      .filter((handle) => handle && handle !== current)
      .slice(0, Number(root.dataset.limit || 4));
    if (!handles.length) return;

    const cards = [];
    for (const handle of handles) {
      try {
        const product = await fetch(`/products/${handle}.js`).then((res) => res.json());
        const image = product.featured_image || "";
        cards.push(`
          <article class="product-card">
            <a class="product-card__media" href="/products/${product.handle}">
              ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : `<div class="media-placeholder"></div>`}
            </a>
            <div class="product-card__info">
              <h3 class="product-card__title"><a href="/products/${product.handle}">${product.title}</a></h3>
              <div class="price">${money(product.price)}</div>
            </div>
          </article>
        `);
      } catch (error) {
        console.warn("Recently viewed product failed", handle, error);
      }
    }

    if (cards.length) {
      const heading = root.dataset.heading || "More from your recent picks";
      root.innerHTML = `<div class="product-rail-heading"><h2>${heading}</h2></div><div class="product-scroller product-scroller--edge">${cards.join("")}</div>`;
    }
  }

  function initInfiniteScroll() {
    const grid = qs(SELECTORS.infiniteGrid);
    const nextLink = qs("[data-next-page]");
    if (!grid || !nextLink || grid.dataset.infinite !== "true" || !("IntersectionObserver" in window)) return;

    let loading = false;
    const sentinel = document.createElement("div");
    sentinel.setAttribute("aria-hidden", "true");
    grid.after(sentinel);

    const observer = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting || loading || !nextLink.href) return;
      loading = true;
      try {
        const html = await fetch(nextLink.href).then((res) => res.text());
        const doc = new DOMParser().parseFromString(html, "text/html");
        const incomingCards = qsa("[data-product-card]", doc);
        incomingCards.forEach((card) => grid.appendChild(card));
        const incomingNext = qs("[data-next-page]", doc);
        if (incomingNext) {
          nextLink.href = incomingNext.href;
        } else {
          nextLink.removeAttribute("href");
          observer.disconnect();
        }
      } catch (error) {
        console.warn("Infinite scroll failed", error);
      } finally {
        loading = false;
      }
    }, { rootMargin: "480px" });

    observer.observe(sentinel);
  }

  function initPreviewTabs() {
    qsa("[data-preview-tab]").forEach((button) => {
      button.addEventListener("click", () => {
        const target = qs(button.dataset.previewTab);
        if (!target) return;
        qsa("[data-preview-panel]").forEach((panel) => {
          panel.hidden = panel !== target;
        });
        qsa("[data-preview-tab]").forEach((tab) => tab.classList.remove("is-active"));
        button.classList.add("is-active");
      });
    });
  }

  function ensurePreviewFooter() {
    if (qs(".site-footer") || !/^(localhost|127\.0\.0\.1|\[::1\]|::1)$/.test(window.location.hostname)) return;

    const footer = `
      <footer class="site-footer">
        <div class="site-footer__inner rr-page-width">
          <div class="site-footer__lead">
            <a class="site-footer__logo" href="/"><img class="site-footer__logo-image" src="/assets/raveready-logo-white.png" alt="raveready" width="220" height="46"></a>
            <div>
              <p class="site-footer__signup-text">Sign up for Early Access for New Drops and Restocks.</p>
            </div>
            <form class="footer-signup">
              <label class="sr-only" for="PreviewFooterEmailGlobal">Email address</label>
              <input id="PreviewFooterEmailGlobal" class="footer-signup__input" type="email" placeholder="E-mail">
              <button class="footer-signup__button" type="submit" aria-label="Sign up"><span aria-hidden="true">&rsaquo;</span></button>
            </form>
          </div>
          <div class="site-footer__columns">
            <nav class="site-footer__column" aria-label="Help">
              <h3 class="site-footer__heading">Help</h3>
              <div class="footer-links"><a href="/pages/help/">Help Center</a><a href="/pages/contact/">Contact Us</a><a href="/account/">Account</a><a href="/pages/returns/">Returns Portal</a><a href="/policies/privacy-policy/">Privacy Policy</a><a href="/policies/terms-of-service/">Terms of Service</a></div>
            </nav>
            <nav class="site-footer__column" aria-label="Brand">
              <h3 class="site-footer__heading">Brand</h3>
              <div class="footer-links"><a href="/pages/under-new-ownership/">Meet raveready</a><a href="/blogs/news/">Blog</a><a href="/pages/help/">Help Center</a><a href="/pages/accessibility/">Accessibility</a><a href="/pages/contact/">Contact</a></div>
            </nav>
            <nav class="site-footer__column" aria-label="Categories">
              <h3 class="site-footer__heading">Categories</h3>
              <div class="footer-links"><a href="/collections/new-arrivals/">New</a><a href="/collections/best-sellers/">Best Sellers</a><a href="/collections/psychedelic/">Psychedelic</a><a href="/collections/techno/">Techno</a><a href="/collections/fairy/">Fairy</a><a href="/collections/sale/">Sale</a></div>
            </nav>
          </div>
        </div>
        <div class="site-footer__bottom rr-page-width">
          <div class="site-footer__utility">
            <div class="site-footer__localization"><span class="footer-country-select footer-country-select--static"><span class="footer-country-select__flag" aria-hidden="true"></span><span>United States (USD $)</span></span></div>
            <p class="site-footer__copyright">&copy; 2026, raveready. POS and Ecommerce by Shopify</p>
          </div>
          <ul class="site-footer__payments" aria-label="Payment methods">
            <li><span class="site-footer__payment-chip site-footer__payment-chip--amazon">amazon</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--amex">AMEX</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--apple">Pay</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--diners">D</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--discover">DISCOVER</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--gpay">G Pay</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--mastercard">MC</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--shop">shop</span></li>
            <li><span class="site-footer__payment-chip site-footer__payment-chip--visa">VISA</span></li>
          </ul>
        </div>
      </footer>
    `;
    const firstDrawer = qs(".drawer");
    if (firstDrawer) {
      firstDrawer.insertAdjacentHTML("beforebegin", footer);
    } else {
      document.body.insertAdjacentHTML("beforeend", footer);
    }
  }

  function normalizeFooterPath(path) {
    const url = new URL(path, window.location.origin);
    let pathname = url.pathname.toLowerCase();
    pathname = pathname.replace(/\/index\.html$/, "");
    pathname = pathname.replace(/\/+$/, "");
    return pathname || "/";
  }

  function markCurrentFooterLinks() {
    const currentPath = normalizeFooterPath(window.location.href);

    qsa(".site-footer .footer-links a").forEach((link) => {
      const linkPath = normalizeFooterPath(link.href);
      const isCurrent = linkPath !== "/" && (currentPath === linkPath || currentPath.startsWith(`${linkPath}/`));

      link.classList.toggle("is-current", isCurrent);
      if (isCurrent) {
        link.setAttribute("aria-current", "page");
      } else if (link.getAttribute("aria-current") === "page") {
        link.removeAttribute("aria-current");
      }
    });
  }

  function initCartOpenParam() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("cart") === "open") {
      openDrawer("CartDrawer");
    }
  }

  function initCollectionGridControls() {
    qsa(".collection-shop").forEach((shop) => {
      const buttons = qsa("button[data-grid-view]", shop);
      if (!buttons.length) return;

      function activate(view) {
        shop.dataset.gridView = view;
        buttons.forEach((button) => {
          const active = button.dataset.gridView === view;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
      }

      const initial = buttons.find((button) => button.classList.contains("is-active"))?.dataset.gridView
        || shop.dataset.gridView
        || buttons[0].dataset.gridView;

      activate(initial);

      buttons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          activate(button.dataset.gridView);
        });
      });
    });
  }

  function initFilterSortChips() {
    qsa(".facets__sort").forEach((group) => {
      qsa("input[type='radio']", group).forEach((input) => {
        input.addEventListener("change", () => {
          qsa(".facets__sort-chip", group).forEach((chip) => {
            const radio = qs("input[type='radio']", chip);
            chip.classList.toggle("is-active", Boolean(radio && radio.checked));
          });
        });
      });
    });
  }

  function resetFacetPanels(form) {
    qsa("[data-facet-panel]", form).forEach((panel) => {
      panel.hidden = true;
    });
    form.classList.remove("is-subpanel");
    form.closest(".drawer")?.classList.remove("is-filter-subpanel");
  }

  function openFacetPanel(form, panelId) {
    const panel = document.getElementById(panelId);
    if (!panel || !form.contains(panel)) return;
    qsa("[data-facet-panel]", form).forEach((item) => {
      item.hidden = item !== panel;
    });
    form.classList.add("is-subpanel");
    form.closest(".drawer")?.classList.add("is-filter-subpanel");
    const focusTarget = qs("[data-facet-back], button, input, a", panel);
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function initFacetPanels() {
    qsa("[data-facets-form]").forEach((form) => {
      qsa("[data-facet-open]", form).forEach((button) => {
        button.addEventListener("click", () => {
          openFacetPanel(form, button.dataset.facetOpen);
        });
      });

      qsa("[data-facet-back]", form).forEach((button) => {
        button.addEventListener("click", () => {
          resetFacetPanels(form);
        });
      });
    });
  }

  function initHeaderGradient() {
    const header = qs(".site-header");
    if (!header || !document.body.classList.contains("template-index")) return;

    let ticking = false;

    function update() {
      const distance = Math.max(header.offsetHeight * 2.2, 180);
      const progress = Math.min(1, Math.max(0, window.scrollY / distance));
      header.style.setProperty("--rr-header-fill-opacity", progress.toFixed(3));
      document.body.classList.toggle("is-header-filled", progress > 0.42);
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", debounce(update, 150));
  }

  function initScrollRunways() {
    const runways = qsa(SELECTORS.scrollRunway)
      .map((section) => ({
        section,
        track: qs(SELECTORS.scrollRunwayTrack, section),
        enabled: false,
        maxScroll: 0,
        scrollDistance: 0,
        targetScroll: 0,
        currentScroll: 0
      }))
      .filter((item) => item.track);

    if (!runways.length) return;

    const desktopQuery = window.matchMedia("(min-width: 900px)");
    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    let ticking = false;
    let animating = false;

    function updateTargets({ immediate = false } = {}) {
      runways.forEach((item) => {
        if (!item.enabled || item.maxScroll <= 0) return;
        const sectionTop = item.section.getBoundingClientRect().top + window.scrollY;
        const progress = Math.min(1, Math.max(0, (window.scrollY - sectionTop) / item.scrollDistance));
        item.targetScroll = progress * item.maxScroll;
        if (immediate) {
          item.currentScroll = item.targetScroll;
          item.track.scrollLeft = item.currentScroll;
        }
      });
      ticking = false;
      startAnimation();
    }

    function animate() {
      let needsNextFrame = false;

      runways.forEach((item) => {
        if (!item.enabled || item.maxScroll <= 0) return;
        const delta = item.targetScroll - item.currentScroll;

        if (Math.abs(delta) < 0.45) {
          item.currentScroll = item.targetScroll;
        } else {
          item.currentScroll += delta * 0.13;
          needsNextFrame = true;
        }

        item.track.scrollLeft = item.currentScroll;
      });

      if (needsNextFrame) {
        window.requestAnimationFrame(animate);
      } else {
        animating = false;
      }
    }

    function startAnimation() {
      if (animating) return;
      animating = true;
      window.requestAnimationFrame(animate);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => updateTargets());
    }

    function setup() {
      runways.forEach((item) => {
        const canPin = desktopQuery.matches && !reducedMotionQuery.matches;
        const maxScroll = Math.max(0, item.track.scrollWidth - item.track.clientWidth);
        item.enabled = canPin && maxScroll > 4;
        item.maxScroll = maxScroll;

        item.section.classList.toggle("is-scroll-runway", item.enabled);

        if (!item.enabled) {
          item.section.style.removeProperty("--runway-pin-height");
          item.targetScroll = item.track.scrollLeft;
          item.currentScroll = item.track.scrollLeft;
          return;
        }

        item.scrollDistance = Math.max(maxScroll * 1.42, window.innerHeight * 1.2);
        item.section.style.setProperty("--runway-pin-height", `${Math.ceil(window.innerHeight + item.scrollDistance)}px`);
      });
      updateTargets({ immediate: true });
    }

    setup();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", debounce(setup, 150));
    window.addEventListener("load", setup, { once: true });

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", setup);
      reducedMotionQuery.addEventListener("change", setup);
    }
  }

  function initDragScroll() {
    qsa(SELECTORS.dragScroll).forEach((scroller) => {
      const scrollRunway = scroller.closest(SELECTORS.scrollRunway);
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      scroller.addEventListener("pointerdown", (event) => {
        if (event.button !== 0) return;
        isDown = true;
        startX = event.clientX;
        scrollLeft = scroller.scrollLeft;
        scroller.classList.add("is-dragging");
        scroller.setPointerCapture(event.pointerId);
      });

      scroller.addEventListener("pointermove", (event) => {
        if (!isDown) return;
        event.preventDefault();
        scroller.scrollLeft = scrollLeft - (event.clientX - startX);
      });

      function endDrag(event) {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove("is-dragging");
        if (event.pointerId && scroller.hasPointerCapture(event.pointerId)) {
          scroller.releasePointerCapture(event.pointerId);
        }
      }

      scroller.addEventListener("pointerup", endDrag);
      scroller.addEventListener("pointercancel", endDrag);
      scroller.addEventListener("mouseleave", () => {
        isDown = false;
        scroller.classList.remove("is-dragging");
      });

      scroller.addEventListener("wheel", (event) => {
        if (scrollRunway && scrollRunway.classList.contains("is-scroll-runway")) return;
        if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        event.preventDefault();
        scroller.scrollLeft += event.deltaY;
      }, { passive: false });
    });
  }

  document.addEventListener("click", (event) => {
    const quickAddButton = event.target.closest(SELECTORS.quickAddOpen);
    if (quickAddButton) {
      event.preventDefault();
      openQuickAdd(quickAddButton);
      return;
    }

    if (event.target.closest(SELECTORS.quickAddClose) || event.target.classList.contains("quick-add-modal__overlay")) {
      event.preventDefault();
      closeQuickAdd();
      return;
    }

    const drawerButton = event.target.closest(SELECTORS.drawerTrigger);
    if (drawerButton) {
      event.preventDefault();
      openDrawer(drawerButton.dataset.drawerTarget);
      return;
    }

    const modalButton = event.target.closest(SELECTORS.modalTrigger);
    if (modalButton) {
      event.preventDefault();
      openModal(modalButton.dataset.modalTarget);
      return;
    }

    if (event.target.closest(SELECTORS.drawerClose) || event.target.closest(SELECTORS.drawerOverlay)) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.closest(SELECTORS.modalClose) || event.target.classList.contains("modal__overlay")) {
      event.preventDefault();
      closeModal();
      return;
    }

    const thumbnail = event.target.closest(".product-thumbnail");
    if (thumbnail) {
      const nav = thumbnail.closest(".product-thumbnails");
      if (nav) {
        qsa(".product-thumbnail", nav).forEach((item) => item.classList.remove("is-active"));
        thumbnail.classList.add("is-active");
      }
    }

    handleQuantityClick(event);
    handleCartChange(event);
  });

  document.addEventListener("submit", handleQuickAdd);
  document.addEventListener("keydown", trapEscape);

  document.addEventListener("DOMContentLoaded", () => {
    initVariantForms();
    initStickyAtc();
    loadRecommendations();
    rememberProduct();
    hydrateRecentlyViewed();
    initInfiniteScroll();
    initPreviewTabs();
    ensurePreviewFooter();
    markCurrentFooterLinks();
    initCartOpenParam();
    initCollectionGridControls();
    initFilterSortChips();
    initFacetPanels();
    initHeaderGradient();
    initScrollRunways();
    initDragScroll();
  });
})();
